/**
 * Action types for wids report functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle wids report list.
 */

// Get wids report constants
export const WIDS_REPORT_REQUEST_GET = 'WIDS_REPORT_REQUEST_GET';
export const WIDS_REPORT_RESPONSE_GET_SUCCESS = 'WIDS_REPORT_RESPONSE_GET_SUCCESS';
export const WIDS_REPORT_RESPONSE_GET_FAIL = 'WIDS_REPORT_RESPONSE_GET_FAIL';

// Delete wids report constants
export const WIDS_REPORT_REQUEST_PUT = 'WIDS_REPORT_REQUEST_PUT';
export const DELETE_WIDS_REPORT_RESPONSE_SUCCESS = 'DELETE_WIDS_REPORT_RESPONSE_SUCCESS';
export const WIDS_REPORT_RESPONSE_PUT_FAIL = 'WIDS_REPORT_RESPONSE_PUT_FAIL';

// Get wids report constants
export const WIDS_REPORT_REQUEST_GET_DOWNLOAD = 'WIDS_REPORT_REQUEST_GET_DOWNLOAD';
export const WIDS_REPORT_RESPONSE_GET_DOWNLOAD_SUCCESS = 'WIDS_REPORT_RESPONSE_GET_DOWNLOAD_SUCCESS';
export const WIDS_REPORT_RESPONSE_GET_DOWNLOAD_FAIL = 'WIDS_REPORT_RESPONSE_GET_DOWNLOAD_FAIL';